import React, {useEffect, useState, Component} from 'react';
import { Link } from 'react-router-dom';
import FirebaseService from '../../services/firebase';
import './style.css';

export default function Dashboard() {
    const [meetings, setMeetings] = useState([]);
    const userId = localStorage.getItem('user');
    const [addiction, setAddiction] = useState({});

    useEffect(() => {

        async function loadAddictions() {            
            const response = await FirebaseService.getAddicts();
            let data = {};
            response.forEach(value => {
                data[value.id] = value.get('pt');
            });

            setAddiction(data);
        }

        async function loadSpots() {            
            const response = await FirebaseService.getMeetingList();
            let data = [];
            response.forEach(value => data.push(value.data()));

            setMeetings(data);
        }
        loadAddictions()
        loadSpots();

    }, [])

    function getMeetingDay(timestamp) {
        let today = new Date();
        let tomorrow = new Date();
        let meetingDate = timestamp.toDate();
        today.setHours(0, 0, 0, 0);
        tomorrow.setDate(today.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        meetingDate.setHours(0, 0, 0, 0);
    
        if(tomorrow.toISOString() == meetingDate.toISOString()){
            return 'Amanhã';
        }
    
        if(timestamp.toDate() > new Date() && timestamp.toDate() < tomorrow){
            return 'Hoje';
        }
    
        if(timestamp.toDate() <= new Date()){
            return 'Agora';
        }
    
        const locales = 'pt-BR';
        const dateString = { weekday: 'long', month: '2-digit', day: 'numeric' };
        const string = timestamp.toDate().toLocaleDateString(locales, dateString).split(',');
        return string[0].split('-')[0] + ' - ' + string[1] + ' - ' + timestamp.toDate().getHours() + 'h';
      }

    return (
        <>
            <Link to="/new">
                <button className="btn">Cadastrar novo Spot</button>
            </Link>
            <ul className="spot-list">
                {meetings.map(meeting => (
                    <li key={meeting.id}>
                        <div>
                            <b className='addict'>{addiction[meeting.addictionId]}</b>
                            <span className='date'>{getMeetingDay(meeting.date)}</span>
                            <a className='link' href={meeting.link} target="_blank" rel="noopener noreferrer">{meeting.link}</a>
                        </div>
                        <Link to={{
                            pathname: '/new',
                            state: meeting
                        }}>
                            <button className="btn">editar</button>
                        </Link>
                    </li>
                ))}
            </ul>
        </>
    )
}